import handleReviewSlider from "../sliders/reviewSlider";

export default function handleReviewNavigation() {
  $(".js-review-tab-nav").on("click", function (e) {
    e.preventDefault();
    const target = $(this).attr("href");
    $(".review-tab").removeClass("review-tab--visible");
    $(target).addClass("review-tab--visible");
    $(".review-carousel").slick("unslick");
    handleReviewSlider($(".review-carousel"));
  });
}

handleReviewNavigation();
